import * as ActionTypes from '../constants';

export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_LIBRARY_SUBJECTS: 
            return {
                ...state,
                loading: true,
                error:false,
                errInfo: null,
                response: null
            }
        case ActionTypes.RECEIVED_LIBRARY_SUBJECTS: 
            return {
                ...state,
                loading: false,
                response: action.res,              
                error: false,
                errInfo: null
            }
        case ActionTypes.ERROR_LIBRARY_SUBJECTS:
            return {
                ...state,
                loading: false,
                error: true,
                errInfo: action.err,
                response: null
            }
        case ActionTypes.CLEAR_LIBRARY_SUBJECTS:
            return { }
        default :  return state
    }
}

